export default class Skill {
  constructor(id: number, name: string, isActive: boolean) {
    this.id = id;
    this.name = name;
    this.isActive = isActive;
  }

  public id: number;
  public name: string;
  public isActive: boolean;

  get stateAsClassName(): string {
    return this.isActive ? "activ" : "";
  }
}
